export class CanaisComunicacaoWhatsAppTexto {
  public phone: string;
  public message: string;
  public guidclientenapis: string;

  constructor() { }
}
